import {
  IPartner,
  IPartnerApp,
  IPartnerTestAccount,
  IUser,
  PartnerCollection,
  PartnerStatus,
  RootCollection,
} from '@principle-theorem/principle-core/interfaces';
import {
  all$,
  asColRef,
  AtLeast,
  CollectionReference,
  IReffable,
  multiSortBy$,
  nameSorter,
  subCollection,
  undeletedQuery,
  WithRef,
} from '@principle-theorem/shared';
import { sortBy } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class Partner {
  static init(
    overrides: AtLeast<IPartner, 'name' | 'regions' | 'description'>
  ): IPartner {
    return {
      deleted: false,
      status: PartnerStatus.Test,
      ...overrides,
    };
  }

  static col(): CollectionReference<IPartner> {
    return asColRef<IPartner>(RootCollection.Partners);
  }

  static all$(): Observable<WithRef<IPartner>[]> {
    return all$(this.col()).pipe(map((partners) => sortBy(partners, ['name'])));
  }

  static appCol(
    partner: IReffable<IPartner>
  ): CollectionReference<IPartnerApp> {
    return subCollection<IPartnerApp>(partner, PartnerCollection.Apps);
  }

  static apps$(
    partner: IReffable<IPartner>
  ): Observable<WithRef<IPartnerApp>[]> {
    return all$(undeletedQuery(Partner.appCol(partner))).pipe(
      multiSortBy$(nameSorter())
    );
  }

  static userCol(partner: IReffable<IPartner>): CollectionReference<IUser> {
    return subCollection<IUser>(partner, PartnerCollection.Users);
  }

  static users$(partner: IReffable<IPartner>): Observable<WithRef<IUser>[]> {
    return all$(Partner.userCol(partner)).pipe(multiSortBy$(nameSorter()));
  }

  static testAccountCol(
    app: IReffable<IPartner>
  ): CollectionReference<IPartnerTestAccount> {
    return subCollection<IPartnerTestAccount>(
      app,
      PartnerCollection.TestAccounts
    );
  }

  static testAccounts$(
    app: IReffable<IPartner>
  ): Observable<WithRef<IPartnerTestAccount>[]> {
    return all$(undeletedQuery(Partner.testAccountCol(app)));
  }
}
